export default "__VITE_ASSET__Z9niOT1N__"